import React from 'react';
import styled from 'styled-components';

const QuestionMark = () => {
return(
    <Container>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g id="Group">
                <g id="Group_2">
                    <path id="Vector"
                          d="M8 0.370605C3.57841 0.370605 0 3.94861 0 8.37061C0 12.7921 3.578 16.3706 8 16.3706C12.4216 16.3706 16 12.7926 16 8.37061C16 3.94901 12.422 0.370605 8 0.370605ZM7.76328 12.1149C7.31047 12.1149 6.96297 11.7359 6.96297 11.3041C6.96297 10.8618 7.321 10.4933 7.76328 10.4933C8.20559 10.4933 8.57409 10.8618 8.57409 11.3041C8.57409 11.7358 8.21606 12.1149 7.76328 12.1149ZM8.96372 8.01861C8.38456 8.47142 8.374 8.78732 8.374 9.33489C8.374 9.53501 8.26869 9.76667 7.75272 9.76667C7.32094 9.76667 7.17356 9.6087 7.17356 9.06114C7.17356 8.15551 7.57372 7.72376 7.87909 7.46051C8.22659 7.16564 8.81631 6.83923 8.81631 6.27061C8.81631 5.78617 8.39509 5.55451 7.86856 5.55451C6.79447 5.55451 7.02616 6.36539 6.45747 6.36539C6.17316 6.36539 5.82566 6.17579 5.82566 5.76514C5.82566 5.19651 6.47853 4.35404 7.90016 4.35404C9.24803 4.35404 10.1431 5.10173 10.1431 6.09157C10.1431 7.08142 9.24803 7.79748 8.96372 8.01861Z"
                          fill="#333333"/>
                </g>
            </g>
        </svg>
    </Container>
)

}
export default QuestionMark;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;